import React from "react";

import { Container, Typography } from "@mui/material";

import FiltersReport from "../components/FiltersReport";
import ReportBuilder, {
    fields_OverviewTable,
} from "../components/shared/ReportBuilder/ReportBuilder";
import {
    COMPARISON_SAME_TIME_LAST_YEAR,
    DATATYPE_CHECKIN,
    DISPLAY_ELEMENT_HELPER,
    GROUP_DATE_DAY,
    GROUP_DATE_MONTH,
    GROUP_DATE_YEAR,
    PRESET_ANYTIME,
    PRESET_THIS_YEAR,
    PRESET_CHOOSE_MONTH,
    PRESET_NEXT_12_MONTHS,
    PRESET_NEXT_30_DAYS,
    PRESET_NEXT_3_MONTHS,
    PRESET_NEXT_MONTH,
    PRESET_THIS_MONTH,
} from "../helpers/filters";
import { TARGET_OFF } from "../helpers/targets";
import { REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY } from "../components/shared/ReportBuilder/ReportChartTrendDailyWeeklyMonthly";
import { REPORT_TABLE_METRICS_SUMMARY } from "../components/shared/ReportBuilder/ReportTableMetricsSummary";
import { REPORT_TABLE_OVERVIEW_YEAR_MONTH } from "../components/shared/ReportBuilder/ReportTableOverviewYearMonth";

const REPORTS = [
    {
        type: REPORT_TABLE_METRICS_SUMMARY,
        groupBy: [],
        dataType: DATATYPE_CHECKIN,
        fieldsOrder: [
            "revenueRoom",
            "bookingsRooms",
            "roomNightsTotal",
            "bookingsCancelled",
            "ADRTotal",
            "ABWTotal",
            "ALoSTotal",
            "revenueExtras",
        ],
        hideFields: [
            ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
                (e) =>
                    ![
                        "revenueRoom",
                        "roomNightsTotal",
                        "ADRTotal",
                        "ABWTotal",
                        "ALoSTotal",
                        "bookingsRooms",
                        "revenueExtras",
                        "bookingsCancelled",
                    ].includes(e),
            ),
        ],
        PDF: "Metrics",
        // props: { hideEvents: true },
    },
    {
        type: REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
        // dataType: DATATYPE_CHECKIN,
        groupBy: [
            // GROUP_OFFERS,
            GROUP_DATE_YEAR,
            GROUP_DATE_MONTH,
            GROUP_DATE_DAY,
        ],
        filters: { Types: ["Special Offer"] },
        props: {
            title: "Arrivals chart",
            description:
                "Shows performance across the selected arrival period, grouped by day, week or month. Current results are compared with the equivalent arrival period at the same booking position last year.",

            metricsTitle: "‎ ",
            metrics: {
                bookingsTotal: {
                    ...DISPLAY_ELEMENT_HELPER.bookingsTotal,
                    short: "Arrivals",
                },
                roomNightsTotal: { ...DISPLAY_ELEMENT_HELPER.roomNightsTotal },
                revenueRoom: { ...DISPLAY_ELEMENT_HELPER.revenueRoom },
                ADRTotal: { ...DISPLAY_ELEMENT_HELPER.ADRTotal },
            },
            showLastYear: true,
        },
    },
    {
        type: REPORT_TABLE_OVERVIEW_YEAR_MONTH,
        props: {
            title: "Arrivals by Month",
            description:
                "Groups arrival performance by check-in month. For each metric, the table shows the selected period, the equivalent booking position last year and the difference between them.",
        },
        dataType: DATATYPE_CHECKIN,
        groupBy: [GROUP_DATE_YEAR, GROUP_DATE_MONTH],
        ...fields_OverviewTable,
        sortable: [],
        filters: { Types: ["Special Offer"] },
        fieldsOrder: [
            "bookingsRooms",
            // "bookingsTotal",
            "roomNightsTotal",
            "revenueRoom",
            "ADRTotal",
            // "ALoSTotal",
            // "ABWTotal",
            // "BWTotal",
            // "bookingsCancelled",
        ],
        hideFields: [
            ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
                (e) =>
                    ![
                        "bookingsRooms",
                        // "bookingsTotal",
                        "roomNightsTotal",
                        "revenueRoom",
                        "ADRTotal",
                        // "ALoSTotal",
                        // "ABWTotal",
                        // "BWTotal",
                        // "bookingsCancelled",
                    ].includes(e),
            ),
        ],
    },
];

const ArrivalsScreen = () => {
    return (
        <>
            <Container maxWidth={false}>
                <Typography variant="h4" sx={{ mt: 2, mb: 2 }}>
                    Arrival report
                </Typography>
                <Typography variant="subtitle1" color="initial">
                    This report displays arrivals for a selected arrival period,
                    with a year-over-year comparison based on today's date last
                    year. By default, cancelled bookings are excluded. Users can
                    filter the report by Country, Rate Plan, Room Type, and
                    Extras to refine the results.
                </Typography>
                <br />
                <FiltersReport
                    hideExports
                    defaultValues={{
                        dataType: DATATYPE_CHECKIN,
                        presetDate: PRESET_NEXT_12_MONTHS,
                        presetArrivalDate: PRESET_ANYTIME,
                        presetResDate: PRESET_ANYTIME,
                        // filters: { Types: ["Special Offer"] },
                        filters: {
                            Cancellations: "excluded",
                            Comparison: COMPARISON_SAME_TIME_LAST_YEAR,
                            Target: TARGET_OFF,
                            // Types: ["Special Offer"], //TODO: Check this
                        },
                    }}
                    BookingPresetOptions={[
                        PRESET_THIS_MONTH,
                        PRESET_THIS_YEAR,
                        PRESET_NEXT_MONTH,
                        PRESET_NEXT_30_DAYS,
                        PRESET_NEXT_3_MONTHS,
                        PRESET_NEXT_12_MONTHS,
                        PRESET_CHOOSE_MONTH,
                    ]}
                    rename={{
                        TIME_PERIOD: "Arrival period",
                        TIME_RANGE: "Custom Arrival Dates",
                    }}
                    hide={[
                        "DATATYPE",
                        "FILTERS_VOUCHERS",
                        "COMPARISON",
                        // "CANCELLATIONS",
                        "ARRIVAL_PERIOD",
                        "TIME_ARRIVAL_RANGE",
                        "RESDATE_PERIOD",
                        "TIME_BOOKING_RANGE",
                        "FILTERS_TYPES",
                    ]}
                    setProcessed={() => {}}
                />
                <ReportBuilder reports={REPORTS} />
            </Container>
        </>
    );
};

export default ArrivalsScreen;
